import { z } from 'zod';

import { makeTypescriptEnumSchema } from '../enumSchemas';
import objectPassthrough from '../objectPassthrough';
import { WithUnknownValuePlaceholder } from '../unknownValuePlaceholder';

enum LoginSorting {
  changeTimeDesc = 'changeTimeDesc',
  alphabeticalAsc = 'alphabeticalAsc',
}

interface UserClientSettings {
  enableBetaOrganizationUserManagement?: boolean;
  enableBetaHeyloginMe?: boolean;
  enableBetaShareSecrets?: boolean;
  enableBetaLoginScopes?: boolean;
  enableBetaAppOverview?: boolean;
  enableBetaPasskeysWithUi?: boolean;
  sortLoginsBy?: WithUnknownValuePlaceholder<LoginSorting, undefined>;
}

// NOTE: we keep passthrough here so old clients do not drop newer settings

const UserClientSettings = objectPassthrough({
  enableBetaOrganizationUserManagement: z.boolean().optional(),
  enableBetaHeyloginMe: z.boolean().optional(),
  enableBetaShareSecrets: z.boolean().optional(),
  enableBetaLoginScopes: z.boolean().optional(),
  enableBetaAppOverview: z.boolean().optional(),
  enableBetaPasskeysWithUi: z.boolean().optional(),
  sortLoginsBy: makeTypescriptEnumSchema(LoginSorting, undefined).optional(),
});

export { UserClientSettings, LoginSorting };
